declare var pglob : IPhotometerGlobalVar;


module shoppinglist {
  'use strict';

  


	/**
	 * The main controller for the app. The controller:
	 * - retrieves and persists the model via the todoStorage service
	 * - exposes the model to the template and provides event handlers
	 */
  export class ShoppingListViewCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope', 
      'shoppingListService', 
      '$timeout',
      '$element',
      '$window', 
      '$mdDialog',
      '$location',
      '$filter',
      'pageMetaService',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IShoppingListViewCtrlScope,
      private shoppingListService: IShoppingListService,
      private $timeout: ng.ITimeoutService,
      private $element: ng.IRootElementService,
      private $window: ng.IWindowService,
      private $mdDialog: ng.material.IDialogService,
      private $location : ng.ILocationService,
      private $filter : ng.IFilterService,
      private pageMetaService : navigation.IPageMetaService
      ) {

      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.hl = pglob.RouteData.CurrentLanguage.hl;
      
      if ($location.search() && $location.search()['id']) {
        shoppingListService.getListsById($location.search()['id']).then((response) => {
          $scope.list = response.data;
          shoppingListService.calculateAvailability($scope.list);
        }).catch((e) => {
          $scope.error = e.status + ": " + e.statusText;
        }) 
      } else {
        $scope.error = "No list id";
      }
            

    }
    
    getTotalQty(hl) { 
      this.$scope.Availability = this.shoppingListService.calculateAvailability(this.$scope.list); 
      return this.shoppingListService.getQtySummary(this.$scope.list);
    };

    getTotal(yourPriceEnabled : boolean) {
      return this.shoppingListService.getTotal(this.$scope.list, yourPriceEnabled); 
    };

    
    getAvailabilityText(line : ShoppingListLine, hl : string) : string  {
      if (hl == 'D') return line.Availability.TextDe;
      if (hl == 'E') return line.Availability.TextEn;
    };

    openDetailModal(ev: MouseEvent, part: part.Part) : void {

      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: 'PartDetailCtrl',
        templateUrl: 'part/PartDetailCtrl',
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        //fullscreen: true, // Only for -xs, -sm breakpoints.
        locals: {
          partId: part.ID,
          //partToProduct: this.$scope.partToProduct,
          parentScope: this.$scope
        },
      })
    }

    print() {
      var printContents = this.$element.find('#printversion')[0].innerHTML;
      
      var popupWin = window.open('', '_blank');
      popupWin.document.open()
      popupWin.document.write('<html><head><title></title>'
        + '<link rel="stylesheet" type="text/css" href="/res/css/shoppinglist-print.css" />'
        + '</head><body onload="//window.print()">' + printContents + '</html>');


      popupWin.document.title = $('.header h3', popupWin.document).text();

      //inject current date & user -> if we make it the angular way, we have to wait for $digest cycle to finish, 
      //which triggers the popup blocker, or it won't get populated because hidden
      $('.printdate i', popupWin.document).each((index : number, el : Element) => {
          var text = $(el).text();

          text = text.replace(/__ReplaceDate:(.*?)__/, (a, b) => {
            return this.$filter('date')(Date.now(),b);
          });

          text = text.replace(/__User__/, (a, b) => {
            return this.pageMetaService.getPageMeta(navigation.USERNAME);
          });

          $(el).text(text); 
      });

      $(".no-print", popupWin.document).empty();
      $(".flex, .flex-grow, .layout-column", popupWin.document).removeClass('flex flex-grow layout-column');

    };

    appendToShoppingList() {
      this.shoppingListService.appendToList(this.$scope.list.ID, ShoppingListType.Merkliste).then((response) => {
        this.$scope.RequestOnGoing = false;
      });
      this.$scope.RequestOnGoing = true;
    }


  }

}

